import { ChassisButton } from '@components/arsenal/chassis/ChassisButton';
import { ChassisInfo } from '@components/arsenal/chassis/ChassisInfo';
import { ArsenalHeader } from '@components/arsenal/ArsenalHeader';
import { Upgrade } from '@components/arsenal/upgrade/Upgrade';
import { useHistoryInterceptor } from '@helpers/history';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';
import * as Shared from '@shared/lib';
import { useState } from 'react';

export function ArsenalChassis() {
  const [upgradeChassis, setUpgradeChassis] = useState('');
  const [chassis, setChassis] = useState('');

  const { t } = useTranslation(undefined, { keyPrefix: 'Arsenal.Chassis' });
  const { userData } = useAppStore();

  useHistoryInterceptor(() => {
    if (chassis) { setChassis(''); return true; }
    if (upgradeChassis) { setUpgradeChassis(''); return true; }
    return false;
  }, { disabled: !chassis && !upgradeChassis });

  const chassisArray = Shared.chassisData
    .filter(c => userData.chassis.some(ch => ch.key === c.key))
    .sort((a, _b) => {
      const isActive = userData.chassis.some(c => c.key === a.key && c.active);
      if (isActive) return -1;
      return 1;
    });

  if (chassis) return <ChassisInfo onBack={() => setChassis('')} chassis={chassis} />;
  if (upgradeChassis) return <Upgrade onBack={() => setUpgradeChassis('')} value={upgradeChassis} type="chassis" />;

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <ArsenalHeader description={t('description')} title={t('title')} bg="chassis.avif" />
      <div className="flex-1 overflow-y-auto">
        <div className="grid grid-cols-2 lg:grid-cols-3">
          {chassisArray.map((c, index) => (
            <ChassisButton
              onUpgrade={() => setUpgradeChassis(c.key)}
              onView={() => setChassis(c.key)}
              index={index}
              key={index}
              chassis={c}
            />
          ))}
        </div>
      </div>
    </div>
  );
}